.errorDialog {
    padding: 0;
}

.errorDialogMessage {
    font-size: 1rem;
    width: 100%;
    padding: var(--bi-scale-4x);
    gap: var(--bi-scale-2x);

    h2 {
        font-weight: 700;
        font-size: 1.25rem;
    }
}
